import { render, staticRenderFns } from "./DishList.vue?vue&type=template&id=91cdb94e&scoped=true&"
import script from "./DishList.vue?vue&type=script&lang=ts&"
export * from "./DishList.vue?vue&type=script&lang=ts&"
import style1 from "./DishList.vue?vue&type=style&index=1&id=91cdb94e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cdb94e",
  null
  
)

export default component.exports